import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '@/lib/supabase'
import { Button, ErrorNote } from '@/components/ui'
import { AuthLayout } from '@/components/AuthLayout'

/** R3: partners reset their own passwords without contacting the team. */
export function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setError(null)
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/auth/callback`,
    })
    if (error) setError('That reset could not be sent. Check the address and try again.')
    else setSent(true)
  }

  return (
    <AuthLayout>
      <h1 className="font-display text-2xl text-pounamu">Reset your password</h1>
      {sent ? (
        <p className="mt-3 text-sm text-inksoft">
          If that address has an account, a reset link is on its way. The link works once and
          expires after 24 hours.
        </p>
      ) : (
        <form onSubmit={submit} className="mt-5 rounded-lg border border-line bg-surface p-5">
          <label className="block text-sm font-medium text-ink" htmlFor="reset-email">
            Email address
          </label>
          <input
            id="reset-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded-sm border border-line px-3 py-2 text-sm"
          />
          {error && <div className="mt-4"><ErrorNote>{error}</ErrorNote></div>}
          <Button type="submit" className="mt-5 w-full">Send the reset link</Button>
        </form>
      )}
      <p className="mt-6 text-sm">
        <Link to="/sign-in" className="text-pounamu underline underline-offset-4">Back to sign in</Link>
      </p>
    </AuthLayout>
  )
}
